import React from 'react';
import { Image, UIText2 } from '@cian/ui-kit';

import styles from './styles.css';

export type BankLogoListProps = {
  banks: string[];
};

export const BanksLogoList: React.FC<BankLogoListProps> = ({ banks }) => {
  const logoListToShow = banks.slice(0, 5);
  const isLogosNeedToSlice = banks.length > 5;

  return (
    <div className={styles['root']}>
      {logoListToShow.map((logo, index) => {
        return (
          <div key={index} className={styles['logo']}>
            <Image src={logo} alt={''} borderRadius={'50%'} preloader />
          </div>
        );
      })}
      {isLogosNeedToSlice && (
        <div key={banks.length} className={styles['logo']}>
          <UIText2 color={'text-secondary-default'}>+{banks.length - 5}</UIText2>
        </div>
      )}
    </div>
  );
};

BanksLogoList.displayName = 'BanksLogoList';
